import React from 'react'
import styles from './styles.module.scss'

interface MarkerPorps {
  lat: number
  lng: number
  name: string
  color: string
  onClick?: () => void
}

export const Marker = ({ color, name, onClick }: MarkerPorps) => {
  return (
    <div>
      <div
        className={`${styles.pin} ${styles.bounce}`}
        style={{ backgroundColor: color, cursor: 'pointer' }}
        title={name}
        onClick={onClick}
      />
      <div className={`${styles.pulse}`} />
    </div>
  )
}
